import axios from "@/libs/api.request";

export const getAdPositionList = filterCond => {
  return axios.request({
    url: "ad/getAdPositionList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const getAdList = filterCond => {
  return axios.request({
    url: "ad/getAdList",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};

export const storeAdData = data => {
  return axios.request({
    url: "ad/storeAdData",
    data: data,
    method: "post"
  });
};

export const storeAdPositionData = data => {
  return axios.request({
    url: "ad/storeAdPositionData",
    data: data,
    method: "post"
  });
};
